import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { PublicSvgIcon } from "../public_svg_icon";

export interface InfoBannerProps {
  title: string;
  message: string;
}
export function InfoBanner({ title, message }: InfoBannerProps) {
  return (
    <Stack
      spacing={2}
      useFlexGap
      sx={{
        mb: { xs: 3, lg: 5 },
        py: 2.5,
        px: 5,
        bgcolor: "info.50",
        borderLeft: 4,
        borderColor: "info.main",
        borderRadius: 2,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <PublicSvgIcon name="info_transparent" size={24} />
        <Typography variant="h6">{title}</Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  );
}
